export const text = {
  title: "Title",
  titlePlaceholder: "Enter Title",
  sendLetter: "Send Newsletter",
  areSure: "Are you sure",
  deleteSubscriber: "You want to delete this subscriber?",
};
